"use client";

import { createContext, type ReactNode, useContext } from "react";
import { FEATURE_FLAGS } from "src/utils/split";

type FeatureName = keyof typeof FEATURE_FLAGS;

type Treatments = Partial<Record<FeatureName, boolean>>;

type FeatureFlagProviderProps = {
  treatments: Treatments;
  children: ReactNode;
};

const FeatureFlagContext = createContext({
  treatments: {} as Treatments,
});

export const useFeatureFlag = (featureName: FeatureName) => {
  const context = useContext(FeatureFlagContext);
  return !!context.treatments?.[featureName];
};

export const FeatureFlagProvider = ({
  treatments,
  children,
}: FeatureFlagProviderProps) => {
  return (
    <FeatureFlagContext.Provider
      value={{
        treatments,
      }}
    >
      {children}
    </FeatureFlagContext.Provider>
  );
};
